import {createApi, createApiClient, initAnalyticsGA, InitParam} from "@3dcalc/3dpClient";
import {initParam, setReady} from "../setting/initParam";

const client = createApiClient({
    apiUrl: 'https://api.deal3dp.ru/api/v1',
    // apiUrl: 'http://localhost:3300/api/v1',
    apiKey: '267420e5bd09907fd9fbc444cae945161291cd6e76dccddf244f42e56997f9d5',
    calculatorId: '39421aa1-13d5-4cf1-9343-d64c58ade97d',
    onError: (error) => {
        console.error('API Error:', error);
    },
    onUnauthorized: () => {
        console.error('Unauthorized! Check your API key');
    }
});

const { config } = await client.init()
setReady(config as InitParam)
initAnalyticsGA({
    calculatorId: '39421aa1-13d5-4cf1-9343-d64c58ade97d',
    calculatorType: 'carport',
    api: client,
});

export const api = createApi(client);

